import { alpha } from '@mui/material/styles';

/**
 * Shared modal layout: fixed title, scrollable body, fixed actions.
 * Scrollbar: thin, dark/neutral (WebKit + Firefox).
 */
export const dialogFormPaperSx = {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'min(90vh, 920px)',
  overflow: 'hidden'
};

export function dialogFormScrollContentSx(theme) {
  const thumb =
    theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.22)' : 'rgba(0,0,0,0.28)';
  const thumbHover =
    theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.38)' : 'rgba(0,0,0,0.45)';
  return {
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    py: 1.5,
    px: 3,
    scrollbarWidth: 'thin',
    scrollbarColor: `${thumb} transparent`,
    '&::-webkit-scrollbar': { width: 9 },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: thumb,
      borderRadius: 8,
      '&:hover': { backgroundColor: thumbHover }
    }
  };
}

export const dialogFormTitleSx = {
  flexShrink: 0,
  px: 3,
  pt: 2.5,
  pb: 1.5,
  borderBottom: 1,
  borderColor: 'divider'
};

export const dialogFormActionsSx = {
  flexShrink: 0,
  px: 3,
  py: 2,
  borderTop: 1,
  borderColor: 'divider',
  gap: 1
};

/** Drag-and-drop / click-to-upload zone: theme-aware hover (no light #f5f5f5 on dark) */
export function uploadDropzoneSx(theme, options = {}) {
  const { mb = 0 } = options;
  const primary = theme.palette.primary.main;
  const hoverBg =
    theme.palette.mode === 'dark' ? alpha(primary, 0.12) : alpha(primary, 0.06);
  return {
    border: '2px dashed',
    borderColor: 'divider',
    borderRadius: 2,
    p: 3,
    textAlign: 'center',
    cursor: 'pointer',
    mb,
    transition: theme.transitions.create(['border-color', 'background-color'], {
      duration: theme.transitions.duration.shortest
    }),
    '&:hover': {
      borderColor: alpha(primary, 0.7),
      backgroundColor: hoverBg
    }
  };
}

export const uploadDropzoneCloudIconSx = {
  fontSize: 48,
  mb: 2,
  color: 'text.secondary',
  opacity: 0.85
};
